import { Card } from '@/shared/ui/Card'
import { Skeleton } from '@/shared/ui/Skeleton'

export type ScheduleSessionCardSkeletonProps = {
  highlight?: boolean
}

export const ScheduleSessionCardSkeleton = ({
  highlight = false
}: ScheduleSessionCardSkeletonProps) => (
  <Card
    className={
      highlight
        ? 'card-gamification border-2 border-brand/20 shadow-sm'
        : 'card-gamification shadow-sm'
    }
  >
    <Card.Body>
      <div className="flex items-start gap-2 sm:gap-3">
        <Skeleton className="mt-0.5 size-8 shrink-0 rounded-lg" />

        <div className="flex min-w-0 flex-1 flex-col gap-1.5">
          <Skeleton variant="pill" className="h-3 w-16" />
          <Skeleton className="h-4 w-[92%]" />
          <Skeleton className="h-3 w-28" />
          <Skeleton className="h-3 w-36" />
        </div>

        <div className="flex min-h-20 w-[70px] shrink-0 flex-col items-end justify-center">
          <Skeleton variant="circle" className="size-11" />
        </div>
      </div>
    </Card.Body>
  </Card>
)
